module.exports = __webpack_public_path__ + "static/media/apartment.2c367882.jpg";